module.exports = __webpack_public_path__ + "static/qb-faq-2656a7d126c45da70e3b86d998fdbd36.jpg";